import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import DataSetService from "../../../../core/services/datasetService.js";
import styles from "./styles.scss";

export default class DatasetWithoutFields extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    let _this = this;
    DataSetService.getDataProfileById(this.props.dataset.dataProfile, (response) => {
      _this.dataProfile = response.data[0];
      _this.firstField = response.data[0].fields[0];
    });
  }

  componentWillReceiveProps(nextProps) {
    let _this = this;
    DataSetService.getDataProfileById(nextProps.dataset.dataProfile, (response) => {
      _this.dataProfile = response.data[0];
      _this.firstField = response.data[0].fields[0];
    });
  }

  componentDidMount() {
    let _this = this;
    this.refs.dataset.addEventListener('dragstart', (e) => {

      let data = {
        dataset: _this.props.dataset,
        field: _this.firstField,
        value: _this.firstField.name,
        dataProfile: _this.dataProfile
      };

      e.dataTransfer.setData("data", JSON.stringify(data));
      this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
    }, false);

    this.refs.dataset.addEventListener('dragend', (e) => {
      this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
    }, false);
  }

  render() {
    return (
      <li className={styles.datasets}>
        <div className={["collapsible-header", styles.header].join(" ")} onClick={this.handleClick}>
          <span className={styles.datasetName} draggable="true" ref="dataset">{this.props.dataset.name}</span>
        </div>
      </li>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/datasetWithoutFields.jsx